import {
  REPORT_UPLOAD,
  REPORT_UPLOAD_FAIL,
  REPORT_UPLOAD_SUCCESS,
  REPORT_VALIDATE,
  REPORT_VALIDATE_SUCCESS,
  REPORT_VALIDATE_FAIL
} from "./actionTypes"

export const reportValidate = (validate) => ({
  type: REPORT_VALIDATE,
  payload: validate
})

export const reportValidateSuccess = validate => ({
  type: REPORT_VALIDATE_SUCCESS,
  payload: validate
})

export const reportValidateFail = error => ({
  type: REPORT_VALIDATE_FAIL,
  payload: error
})

export const reportUpload = (batchId) => ({
  type: REPORT_UPLOAD,
  batchId
})

export const reportUploadSuccess = report => ({
  type: REPORT_UPLOAD_SUCCESS,
  payload: report
})

export const reportUploadFail = error => ({
  type: REPORT_UPLOAD_FAIL,
  payload: error
})



